import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import { useHistory } from "react-router";
import Swal from "sweetalert2";
import * as Yup from "yup";
import { URL_REGEX } from "../../../utils/Constants";
import Select from "react-select";
import {
  GetBrandSettingCommonContent,
  AddBrandSettingAPI,
  GetNetsuiteERPBrandNameList
} from "../../../services/BrandServices";
import { GetCampusMgtList } from "../../../services/CampusMgtService";
import axios from "axios";
import { generateObjectURL, generatePreviewURLForBrand } from "../../../utils/commonFunction";

const AddBrandSetting = () => {
  const history = useHistory();
  const [disabled, setDisabled] = useState(false);
  const [CRMBrandName, setCRMBrandName] = useState([]);
  const [ERPBrandName, setERPBrandName] = useState([]);
  const [brandWelcomeLetter, setBrandWelcomeLetter] = useState([]);
  const [campusList, setCampusList] = useState([]);

  const SUPPORTED_FORMATS = ["image/jpg", "image/jpeg", "image/png"];

  const basename = (path) => {
    return path?.split("/").reverse()[0] || "";
  };

  // Helper function to get image preview URL
  const getImagePreviewUrl = (path) => {
    if (!path) return null;
    if (path instanceof File) return generateObjectURL(path);
    return generatePreviewURLForBrand(path);
  };

  // Helper function to handle file changes
  const handleFileChange = (fieldName, e, formik) => {
    if (e.target.files.length) {
      const file = e.target.files[0];
      formik.setFieldValue(fieldName, file);
    } else {
      formik.setFieldValue(fieldName, "");
    }
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      BrandName: "",
      Mobile: "",
      Domain: "",
      tandc_url: "",
      ERPBrandName: "",
      CRMBrandName: "",
      ERPBrandNameID: "",
      CRMBrandNameID: "",
      LetterheadHeader: "",
      LetterheadFooter: "",
      EmailDomain: "",
      photo: "",
      PortalTitle: "",
      IOS_url: "",
      Android: "",
      StudentCardQR: "",
      BrandWelcomeLetter: "",
      campus_locations: [],
      signature: "",
      hauwei: "",
      pmc_rereg_video_iframe: "",
      pmc_rereg_fallback_video: ""
    },
    validationSchema: Yup.object({
      BrandName: Yup.string()
        .trim("The Brand name cannot include leading and trailing spaces")
        .required("Brand Name is required"),
      Mobile: Yup.string().required("Contact Number Is Required"),
      CRMBrandName: Yup.string().required("CRM Brand Name is required"),
      Domain: Yup.string()
        .url("Please Enter Domain URL")
        .matches(URL_REGEX, "Domain URL is not valid")
        .required("Domain Url Is Required"),
      tandc_url: Yup.string()
        .url("Please Enter Terms & Condition URL")
        .matches(URL_REGEX, "Terms & Conditions URL is not valid")
        .required("Terms & Condition URL is required"),
      EmailDomain: Yup.string()
        .required("Email Domain Is Required")
        .trim("Enter Valid Email Domain"),
      LetterheadHeader: Yup.mixed().required("Letterhead Header image Required"),
      LetterheadFooter: Yup.mixed().required("Letterhead Footer image Required"),
      photo: Yup.mixed().required("Student Card image Required"),
      PortalTitle: Yup.string().required("Portal Title is required").trim("Enter valid title"),
      IOS_url: Yup.string().url("Please Enter IOS URL").matches(URL_REGEX, "IOS URL is not valid"),
      Android: Yup.string().url("Please Enter Android URL").matches(URL_REGEX, "Android URL is not valid"),
      StudentCardQR: Yup.string().url("Please Enter Student Card QR URL").matches(URL_REGEX, "Student Card QR URL is not valid").required("Student Card QR Url Is Required"),
      BrandWelcomeLetter: Yup.mixed().required("Welcome Letter is required"),
      campus_locations: Yup.array().min(1, "Campus Location is required"),
      hauwei: Yup.string().url("Please Enter Hauwei URL").matches(URL_REGEX, "Hauwei URL is not valid"),
      signature: Yup.mixed().required("Signature is required"),
    }),
    onSubmit: (values) => {
      setDisabled(true);
      let formData = new FormData();
      formData.append("brand_name", values?.BrandName);
      formData.append("contact", values?.Mobile);
      formData.append("erp_brand", values?.ERPBrandName);
      formData.append("erp_brand_id", values?.ERPBrandNameID);
      formData.append("brand_reg_crm", values?.CRMBrandNameID);
      formData.append("domain_url", values?.Domain);
      formData.append("microsoft_email", values?.EmailDomain);
      formData.append("title", values?.PortalTitle);
      formData.append("androidAppUrl", values?.Android);
      formData.append("iosAppUrl", values?.IOS_url);
      formData.append("studentCardVerifyUrl", values?.StudentCardQR);
      formData.append("campus_location", values.campus_locations);
      formData.append("tandc_url", values?.tandc_url);
      formData.set("hauweiAppUrl", values?.hauwei);
      formData.set("pmc_rereg_video_iframe", values.pmc_rereg_video_iframe);
      formData.set("pmc_rereg_fallback_video", values.pmc_rereg_fallback_video);
      formData.append("letterheadHeader", values.LetterheadHeader);
      formData.append("letterheadFooter", values.LetterheadFooter);
      formData.append("studentCardBackground", values.photo);
      formData.append("brandSignature", values.signature);
      formData.append("brand_welcome_letter", values.BrandWelcomeLetter);

      AddBrandSettingAPI(formData)
        .then((res) => {
          Swal.fire({
            icon: "success",
            title: "Success",
            text: "Added successfully",
          });
          setDisabled(false);
          history.push(
            `/administration/brandSetting/editPortalSetting/visualsTab/${res?.data?.inserted_record}`
          );
        })
        .catch((err) => {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: `${err?.response?.data}`,
          });
          setDisabled(false);
          history.push("/administration/brandSetting/addNewBrand");
        });
    },
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [commonContent, erpBrands, campusData] = await Promise.all([
          GetBrandSettingCommonContent().catch(() => ({
            data: {
              brand_reg_crm: [],
              erp_brand_name: [],
              brand_welcome_letter: [],
            },
          })),
          GetNetsuiteERPBrandNameList().catch(() => ({
            data: {
              data: {
                items: [],
              },
            },
          })),
          GetCampusMgtList({}).catch(() => ({
            data: {
              data_list: [],
            },
          })),
        ]);

        setCRMBrandName(
          commonContent?.data?.brand_reg_crm?.map(data => ({
            value: `${data.value}`,
            label: `${data.title}`
          })) || []
        );

        setBrandWelcomeLetter(
          commonContent?.data?.brand_welcome_letter?.map(data => ({
            value: `${data.value}`,
            label: `${data.title}`
          })) || []
        );

        setERPBrandName(
          erpBrands?.data?.data?.items?.map(data => ({
            value: `${data.id}`,
            label: `${data.fullname}`
          })) || []
        );

        setCampusList(
          campusData?.data?.data_list?.map(val => ({
            label: val.campus_name,
            value: val.id
          })) || []
        );
      } catch (error) {
        console.error("Filename->Failed to load brand settings", error);
        return {
          data: {
            brand_reg_crm: [],
            erp_brand_name: [],
            brand_welcome_letter: [],
          },
        };
      }
    };

    fetchData();
  }, []);

  // File upload component to reduce duplication
  const FileUploadField = ({ label, fieldName, accept = SUPPORTED_FORMATS, required = false }) => {
    const value = formik.values[fieldName];
    const previewUrl = getImagePreviewUrl(value);
    const fileName = value instanceof File ? value.name : basename(value);
    const error = formik.errors[fieldName] && formik.touched[fieldName];

    return (
      <div className="col-md-6 col-lg-4 mb-4">
        <label htmlFor={fieldName}>{label} {required && "*"}</label>
        <div className="form-group atttach-file">
          <label className={error ? "file-req is-invalid" : ""}>
            <i className="fal fa-paperclip"></i>
            <span>Add Attachment</span>
            <input
              type="file"
              id={fieldName}
              className="form-control form-control-aatch-file"
              accept={accept.join(",")}
              onChange={(e) => handleFileChange(fieldName, e, formik)}
            />
          </label>
        </div>
        {previewUrl && (
          <>
            <div className="form-icon-group" title={label}>
              <figure className="upload-img-size" title={label}>
                <img className="" src={previewUrl} alt={label} />
              </figure>
            </div>
            <div className="frm-group">
              <ul className="list-unstyled attached-file-ul m-0">
                <li>
                  <a href={previewUrl} target="_blank" rel="noreferrer">
                    <i className="fal fa-file"></i>
                    &nbsp;{fileName}
                  </a>
                </li>
              </ul>
            </div>
          </>
        )}
      </div>
    );
  };

  return (
    <div className="card card-body-inr">
      <form onSubmit={formik.handleSubmit}>
        <div className="row">
          <div className="col-md-6 col-lg-4">
            <label htmlFor="portalTitle">Portal Title *</label>
            <div className="form-icon-group mb-4" title="Title">
              <input
                type="text"
                id="portalTitle"
                className={"form-control" + (formik.errors.PortalTitle && formik.touched.PortalTitle ? " is-invalid" : "")}
                name="PortalTitle"
                placeholder="Portal Title"
                title="Portal Title"
                value={formik.values.PortalTitle}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
            </div>
          </div>
          <div className="col-md-6 col-lg-4">
            <label htmlFor="IOS_url">IOS App URL</label>
            <div className="form-icon-group mb-4">
              <input
                type="text"
                id="IOS_url"
                className={"form-control" + (formik.errors.IOS_url && formik.touched.IOS_url ? " is-invalid" : "")}
                name="IOS_url"
                title="IOS App URL"
                placeholder="Enter IOS URL"
                value={formik.values.IOS_url?.replace(" ", "")}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
            </div>
          </div>
          <div className="col-md-6 col-lg-4">
            <label htmlFor="android">Android App URL</label>
            <div className="form-icon-group mb-4">
              <input
                type="text"
                id="android"
                className={"form-control" + (formik.errors.Android && formik.touched.Android ? " is-invalid" : "")}
                name="Android"
                title="Android App URL"
                placeholder="Enter Android URL"
                value={formik.values.Android?.replace(" ", "")}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
            </div>
          </div>
          <div className="col-md-6 col-lg-4">
            <label htmlFor="hauwei">Hauwei App URL</label>
            <div className="form-icon-group mb-4">
              <input
                type="text"
                id="hauwei"
                className={"form-control" + (formik.errors.hauwei && formik.touched.hauwei ? " is-invalid" : "")}
                name="hauwei"
                title="Hauwei App URL"
                placeholder="Enter Hauwei URL"
                value={formik.values.hauwei?.replace(" ", "")}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
            </div>
          </div>
          <div className="col-md-6 col-lg-4">
            <label htmlFor="studentCard">Student Card QR *</label>
            <div className="form-icon-group mb-4">
              <input
                type="text"
                id="studentCard"
                className={"form-control" + (formik.errors.StudentCardQR && formik.touched.StudentCardQR ? " is-invalid" : "")}
                name="StudentCardQR"
                title="Student Card QR"
                placeholder="Enter Student Card QR URL"
                value={formik.values.StudentCardQR?.replace(" ", "")}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
            </div>
          </div>
          <div className="col-md-6 col-lg-4">
            <label htmlFor="BrandWelcomeLetter">Welcome Letter *</label>
            <div className="form-icon-group mb-4">
              <Select
                className={"form-control custom-select-box" + (formik.errors.BrandWelcomeLetter && formik.touched.BrandWelcomeLetter ? " is-invalid" : "")}
                name="BrandWelcomeLetter"
                value={brandWelcomeLetter.find(option => option.value == formik.values.BrandWelcomeLetter)}
                onChange={(value) => {
                  formik.setFieldValue("BrandWelcomeLetter", value?.value || "");
                }}
                onBlur={formik.handleBlur}
                options={brandWelcomeLetter}
                maxMenuHeight={175}
                placeholder="Select"
                isClearable
              />
            </div>
          </div>
          <div className="col-md-6 col-lg-4">
            <label htmlFor="campus_locations">Campus Locations *</label>
            <div className="form-icon-group mb-4">
              <Select
                className={"form-control custom-select-box" + (formik.errors.campus_locations && formik.touched.campus_locations ? " is-invalid" : "")}
                name="campus_locations"
                value={campusList.filter(option => formik.values.campus_locations?.includes(option.value))}
                onChange={(value) => {
                  formik.setFieldValue("campus_locations", value?.map(item => item.value) || []);
                }}
                onBlur={formik.handleBlur}
                options={campusList}
                maxMenuHeight={175}
                placeholder="Select"
                isClearable
                isMulti
              />
            </div>
          </div>
          <div className="col-md-6 col-lg-4">
            <label htmlFor="BrandName">Brand Name *</label>
            <div className="form-icon-group mb-4" title="Brand Name">
              <input
                type="text"
                className={
                  "form-control" +
                  (formik.errors.BrandName && formik.touched.BrandName
                    ? " is-invalid"
                    : "")
                }
                name="BrandName"
                id="BrandName"
                placeholder="Brand Name"
                title="Brand Name"
                value={formik.values.BrandName}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
            </div>
          </div>

          <div className="col-md-6 col-lg-4">
            <label htmlFor="Contact">Contact Number *</label>
            <div className="form-icon-group mb-4">
              <input
                type="text"
                className={
                  "form-control" +
                  (formik.errors.Mobile && formik.touched.Mobile
                    ? " is-invalid"
                    : "")
                }
                name="Mobile"
                title="Contact number"
                id="Contact"
                placeholder="Enter Contact Number"
                value={formik.values.Mobile}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
            </div>
          </div>

          <div className="col-md-6 col-lg-4">
            <label htmlFor="ERPBrandName">Netsuite Brand Name</label>
            <div className="form-icon-group mb-4">
              <Select
                className={
                  "form-control custom-select-box " +
                  (formik.errors.ERPBrandName && formik.touched.ERPBrandName
                    ? " is-invalid"
                    : "")
                }                
                name="ERPBrandName"
                value={ERPBrandName.find(option => option.value == formik.values.ERPBrandNameID)}
                onChange={(value) => {
                  formik.setFieldValue("ERPBrandName", value?.label || "");
                  formik.setFieldValue("ERPBrandNameID", value?.value || "");
                }}
                onBlur={formik.handleBlur}
                options={ERPBrandName}
                maxMenuHeight={175}
                placeholder="Select"
                isClearable
              />
            </div>
          </div>
          <div className="col-md-6 col-lg-4">
            <label htmlFor="CRMBrandName">CRM Brand Name *</label>
            <div className="form-icon-group mb-4">
              <Select
                className={"form-control custom-select-box " + (formik.errors.CRMBrandName && formik.touched.CRMBrandName ? " is-invalid" : "")}
                name="CRMBrandName"
                value={CRMBrandName.find(option => option.label == formik.values?.CRMBrandName)}
                onChange={(value) => {
                  formik.setFieldValue("CRMBrandName", value?.label || "");
                  formik.setFieldValue("CRMBrandNameID", value?.value || "");
                }}
                onBlur={formik.handleBlur}
                options={CRMBrandName}
                maxMenuHeight={175}
                placeholder="Select"
                isClearable
              />
            </div>
          </div>
          <div className="col-md-6 col-lg-4">
            <label htmlFor="DomainURL">Domain URL *</label>
            <div className="form-icon-group mb-4">
              <input
                type="text"
                className={
                  "form-control" +
                  (formik.errors.Domain && formik.touched.Domain
                    ? " is-invalid"
                    : "")
                }
                name="Domain"
                id="DomainURL"
                placeholder="Domain URL"
                value={formik.values.Domain}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                title="Domain URL"
              />
            </div>
          </div>
          <div className="col-md-6 col-lg-4">
            <label htmlFor="tandc_url">Terms & Condition URL *</label>
            <div className="form-icon-group mb-4">
              <input
                type="text"
                className={
                  "form-control" +
                  (formik.errors.tandc_url && formik.touched.tandc_url
                    ? " is-invalid"
                    : "")
                }
                name="tandc_url"
                id="tandc_url"
                placeholder="Terms & Condition URL"
                value={formik.values.tandc_url}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                title="Terms & Condition URL"
              />
            </div>
          </div>

          <div className="col-md-6 col-lg-4">
            <label htmlFor="EmailDomain">Email Domain *</label>
            <div className="form-icon-group mb-4">
              <input
                type="text"
                className={
                  "form-control" +
                  (formik.errors.EmailDomain && formik.touched.EmailDomain
                    ? " is-invalid"
                    : "")
                }
                name="EmailDomain"
                id="EmailDomain"
                placeholder="Email Domain"
                value={formik.values.EmailDomain}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                title="Email Domain"
              />
            </div>
          </div>

          <div className="col-md-6 col-lg-4">
            <label htmlFor="pmc_rereg_video_iframe">PMC Re-Reg Video iFrame</label>
            <div className="form-icon-group mb-4" title="Title">
              <input
                type="text"
                id="pmc_rereg_video_iframe"
                className={"form-control" + (formik.errors.pmc_rereg_video_iframe && formik.touched.pmc_rereg_video_iframe ? " is-invalid" : "")}
                name="pmc_rereg_video_iframe"
                placeholder="PMC Re-Reg Video Iframe"
                title="PMC Re-Reg Video Iframe"
                value={formik.values.pmc_rereg_video_iframe || ""}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
            </div>
          </div>

          <div className="col-md-6 col-lg-4 mb-4">
            <label htmlFor="pmc_rereg_fallback_video">
              PMC Re-Reg Fallback Video
            </label>

            <div className="form-group atttach-file">
              <label
                className={`${formik.touched.pmc_rereg_fallback_video &&
                    formik.errors.pmc_rereg_fallback_video
                    ? "file-req is-invalid"
                    : ""
                  }`}
              >
                <i className="fal fa-paperclip"></i>
                <span>Add Attachment</span>
                <input
                  type="file"
                  id="pmc_rereg_fallback_video"
                  name="pmc_rereg_fallback_video"
                  className="form-control form-control-aatch-file"
                  accept="video/*"
                  onChange={(e) => handleFileChange("pmc_rereg_fallback_video", e, formik)}
                />
              </label>
            </div>
            {formik.values.pmc_rereg_fallback_video && (
              <div className="frm-group">
                <ul className="list-unstyled attached-file-ul m-0">
                  <li>
                    <a
                      href={getImagePreviewUrl(formik.values.pmc_rereg_fallback_video)}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i className="fal fa-file-video"></i>
                      &nbsp;
                      {formik.values.pmc_rereg_fallback_video instanceof File
                        ? formik.values.pmc_rereg_fallback_video.name
                        : basename(formik.values.pmc_rereg_fallback_video)}
                    </a>
                    <button
                      type="button"
                      className="btn btn-danger rounded-circle btn-dropdown-item"
                      title="Delete"
                      onClick={() => formik.setFieldValue("pmc_rereg_fallback_video", "")}
                    >
                      <i className="fal fa-trash-alt"></i>
                    </button>
                  </li>
                </ul>
              </div>
            )}
          </div>

          {/* File Upload Fields */}
          <FileUploadField label="Letterhead Header" fieldName="LetterheadHeader" required />
          <FileUploadField label="Letterhead Footer" fieldName="LetterheadFooter" required />
          <FileUploadField label="Student Card Background" fieldName="photo" required />
          <FileUploadField label="Signature" fieldName="signature" required />
        </div>

        <div className="form-group form-group-save-cancel mt-3">
          <button
            className="btn btn-save btn-success"
            type="submit"
            title="Save"
            disabled={disabled}
          >
            {disabled ? (
              <i className="fas fa-cog fa-spin"></i>
            ) : (
              <i className="fal fa-save"></i>
            )}
            Save
          </button>
          <button
            className="btn btn-close btn-danger"
            type="button"
            title="Cancel"
            onClick={() => history.goBack()}
          >
            <i className="fal fa-times"></i>
            Cancel
          </button>

          {Object.keys(formik.values).map(key => {
            if (formik.touched[key] && formik.errors[key]) {
              return (
                <div className="invalid-feedback d-block"
                  key={key}
                >
                  {formik.errors[key]}
                </div>
              );
            }
            return null;
          })}
        </div>
      </form>
    </div>
  );
};

export default AddBrandSetting;